import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import * as fromApp from '../../../app.reducer';
import * as fromNew from '../../new/store/new.reducer';

@Component({
  selector: 'compact-upload-progress',
  templateUrl: './compactUploadProgress.component.html',
  styleUrls: ['./compactUploadProgress.component.scss'],
})
export class CompactUploadProgressComponent implements OnInit {
  @Output() showConfirmCancelUpload = new EventEmitter();
  @Input() isWizardPage;
  @Input() isContibution;
  @Input() isDesigning;
  hidden = false;
  submitting = true;
  uploadStatus: fromNew.State;

  constructor(
    private translate: TranslateService,
    private store: Store<fromApp.AppState>,
  ) {}

  ngOnInit() {
    this.store.select('new').subscribe(storyUploading => {
      this.uploadStatus = storyUploading;
    });
  }

  cancelUpload() {
    this.showConfirmCancelUpload.emit();
  }

  hide() {
    this.hidden = true;
  }

  get isUploading() {
    return this.uploadStatus.uploadStatus.status === 'uploading';
  }

  get isThumbsUploading() {
    return (this.uploadStatus.uploadStatus.thmbStatus === 'uploading' && this.uploadStatus.uploadStatus.status !== 'finished');
  }

  get isUploadFinished() {
    return this.uploadStatus.uploadStatus.status === 'finished';
  }
}
